<div [formGroup]="_data.userForm">
  <div formGroupName="additionalFields" class="p-fluid p-formgrid row">
    <div class="p-field col-lg-4 col-sm-4 col-md-12 col-12" *ngIf="_data.userForm &&
    (isFingerprintAdmin || isEppAdmin || isLeaAdmin ||
     (getUserRoleType(_data.userForm.get('userroles')?.value) === ROLE_TYPE_APPLICANT))">
      <label for="suffix">Suffix</label>
      <p-dropdown inputId="suffix" [options]="suffixList" formControlName="cd_suffix" optionLabel="value"
        optionValue="key" placeholder="Select Suffix" class="w-100" [showClear]="true"
        [ngClass]="{
          'is-invalid':
            additionalFields?.get('cd_suffix')?.touched &&
            additionalFields?.get('cd_suffix')?.invalid
        }">
      </p-dropdown>
      <div *ngIf="additionalFields?.get('cd_suffix')?.touched &&
           additionalFields?.get('cd_suffix')?.errors as errors" class="p-error mt-1">
        <div *ngIf="errors['required']">Please select a suffix.</div>
        <div *ngIf="errors['customError']">{{ errors['customError'] }}</div>
      </div>
    </div>
    <div class="p-field col-lg-4 col-sm-4 col-md-12 col-12"
      *ngIf="getUserRoleType(_data.userForm.get('userroles')?.value) === ROLE_TYPE_APPLICANT">
      <label for="recoveryEmailId">Recovery Email</label>
      <input id="recoveryEmailId" pInputText type="text" formControlName="recovery_email" maxlength="255"
        placeholder="Enter Recovery Email" (blur)="checkRecoveryEmail()" [ngClass]="{
      'is-invalid':
        additionalFields?.get('recovery_email')?.touched &&
        additionalFields?.get('recovery_email')?.invalid
    }" />
      <div *ngIf="additionalFields?.get('recovery_email')?.touched &&
           additionalFields?.get('recovery_email')?.errors as errors" class="p-error mt-1">
        <div *ngIf="errors['customError']">{{ errors['customError'] }}</div>
        <div *ngIf="errors['sameAsEmail']">
          Primary and recovery emails must be different.
        </div>
      </div>
      <div *ngIf="recoveryEmailExists" class="p-error mt-1">
        The recovery email entered is already on file.
      </div>
    </div>
    <div class="p-field col-lg-4 col-sm-4 col-md-12 col-12" *ngIf="isFingerprintAdmin ||
    [ROLE_TYPE_FINGERPRINT]
      .includes(getUserRoleType(_data.userForm.get('userroles')?.value))">
      <label for="organization">
        Organization
        <span class="text-danger" *ngIf="!isFingerprintAdmin">*</span>
      </label>
      <input id="organization" pInputText type="text" formControlName="organization" placeholder="Enter Organization"
        (keyup)="onPageNameInput($event, 'additionalFields.organization')" />
      <div *ngIf="additionalFields?.get('organization')?.touched &&
           additionalFields?.get('organization')?.errors as errors" class="p-error mt-1">
        <div *ngIf="errors['required']">Please enter an organization.</div>
        <div *ngIf="errors['customError']">{{ errors['customError'] }}</div>
      </div>
    </div>
    <div class="p-field col-lg-4 col-sm-4 col-md-12 col-12" *ngIf="isEppAdmin ||
    getUserRoleType(_data.userForm.get('userroles')?.value) === ROLE_TYPE_EPP">
      <label for="provider">
        EPP Provider
        <span class="text-danger" *ngIf="!isEppAdmin">*</span>
      </label>
      <p-dropdown inputId="provider" [options]="providerList" formControlName="provider" optionLabel="value"
        optionValue="key" placeholder="Select EPP Provider" class="w-100" [showClear]="true"
        [ngClass]="{
          'is-invalid':
            additionalFields?.get('provider')?.touched &&
            additionalFields?.get('provider')?.invalid
        }">
      </p-dropdown>
      <div *ngIf="additionalFields?.get('provider')?.touched &&
           additionalFields?.get('provider')?.errors as errors" class="p-error mt-1">
        <div *ngIf="errors['required']">EPP Provider is required.</div>
        <div *ngIf="errors['customError']">{{ errors['customError'] }}</div>
      </div>
    </div>
     <div class="p-field col-lg-4 col-sm-4 col-md-12 col-12" *ngIf="isLeaAdmin ||
    getUserRoleType(_data.userForm.get('userroles')?.value) === ROLE_TYPE_LEA">
      <label for="District">
        District
        <span class="text-danger" *ngIf="!isLeaAdmin">*</span>
        <em class="pi pi-info-circle ms-1"
          [pTooltip]="genericMessage['G0089']"
          tooltipPosition="right"
          [tooltipStyleClass]="'district-info-tooltip'"
          aria-label="District association information">
        </em>
      </label>
      <p-multiSelect inputId="district" [options]="districtList" formControlName="district" optionLabel="value"
        optionValue="key" placeholder="Select District" class="w-100" display="chip"
        [ngClass]="{
          'is-invalid':
            (additionalFields?.get('district')?.touched &&
            additionalFields?.get('district')?.invalid) || districtConflict || districtRestrictedConflict
        }">
      </p-multiSelect>
      <div *ngIf="districtConflict" class="p-error mt-1">
        The selected district is already assigned to another user who is responsible for multiple districts. Select a different district or assign this user to all associated districts: <span *ngFor="let name of districtConflictNames; let last = last"><strong>{{name}}</strong><span *ngIf="!last">, </span></span>.
      </div>
      <div *ngIf="districtRestrictedConflict" class="p-error mt-1">
        Only districts associated with <strong>{{districtRestrictedFirstName}}</strong><ng-container
          *ngIf="districtRestrictedAssociatedNames?.length">, <span
            *ngFor="let name of districtRestrictedAssociatedNames; let last = last"><strong>{{name}}</strong><span
              *ngIf="!last">, </span></span></ng-container> can be selected.
      </div>
      <div *ngIf="additionalFields?.get('district')?.touched &&
           additionalFields?.get('district')?.errors as errors" class="p-error mt-1">
        <div *ngIf="errors['required']">District is required.</div>
        <div *ngIf="errors['customError']">{{ errors['customError'] }}</div>
      </div>
    </div>
  </div>
</div>
